<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n7FlKp/tc-custom/9780795320811.jpg?1737681310156" alt="This image is the cover for the book Education of Miss Patterson, The Love and Temptation Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Education of Miss Patterson, The Love and Temptation Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A flirtatious young lady meets the ultimate challenge in her strict new guardian in the <i>New York Times</i>–bestselling author’s charming Regency romance.</b><br/><br/>Miss Patricia Patterson is young, lovely, and more than a little spoiled. Life for her is a delightful dream of carefree days, dazzling balls, and delicious flirtations. But that all changes when she suddenly comes under the care of a new guardian.<br/><br/>Lord Charles demanded that Patricia act the part of a proper and perfectly boring young Miss. Even worse, he insists that she devote her waking hours to cultivating her mind rather than captivating her swarm of admirers. And so begins an epic battle of wills between the handsome, arrogant aristocrat who has Patricia under his lawful power . . . and Patricia, who vows to turn this hateful tyrant into her lovelorn subject . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. C. Beaton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?601b0ec6